import {
  downloadTemplateDOCX,
  downloadTemplatePDF,
  generateTemplateHTML,
} from './htmlResumeTemplates';

export async function generateProfessionalClassicDOCX(resumeData: any): Promise<void> {
  return downloadTemplateDOCX('professional-classic', resumeData);
}

export async function generateProfessionalClassicPDF(resumeData: any): Promise<void> {
  return downloadTemplatePDF('professional-classic', resumeData);
}

export async function generateProfessionalClassicHTML(resumeData: any): Promise<string> {
  return generateTemplateHTML('professional-classic', resumeData);
}
